import { render, staticRenderFns } from "./TransactionsTab.vue?vue&type=template&id=07887fd2"
import script from "./TransactionsTab.vue?vue&type=script&lang=js"
export * from "./TransactionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports